import '@babel/polyfill';
import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import App from './App.vue';
import router from './router';
import store from './store/index';
import sk from './assets/lang/sk';
import dayjs from 'dayjs';
import defaultMixin from './mixins/defaultComponentMixin';
import './style/app.scss';
import Paginate from 'vuejs-paginate';
import Loading from './components/default/Loading.vue';
import MceField from './components/FormFields/MceField.vue';
import ImageField from './components/FormFields/ImageField.vue';
import SelectField from './components/FormFields/SelectField.vue';
import DateField from './components/FormFields/DateField.vue';
import setupInterceptors from './api/interceptors';
import VueWait from 'vue-wait';
import Toasted from 'vue-toasted';
import VueI18n from 'vue-i18n';
import VueLazyload from 'vue-lazyload';
import VueFormly from 'vue-formly';
import VueFormlyBootstrap from 'vue-formly-bootstrap';
import CheckboxField from './components/FormFields/CheckboxField';
import VueScrollTo from 'vue-scrollto';
import VueAnalytics from 'vue-analytics';
import axios from 'axios';
Sentry.init({
  dns: 'https://6284b75071a04af98ec046f2587a2508@sentry.io/1449322',
  integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
  environment: 'production'
});

Vue.use(VueFormly);
Vue.use(VueFormlyBootstrap);
Vue.use(VueScrollTo);
Vue.use(Toasted, {
 iconPack: 'fontawesome'
})

Vue.component('paginate', Paginate);
Vue.component('loading', Loading);
Vue.mixin(defaultMixin);
Vue.use(VueWait);
Vue.use(VueI18n);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/img/error.png',
  loading: '/img/loading.gif',
  attempt: 1
});

export const i18n = new VueI18n({
  locale: 'sk',
  messages: {
    sk
  }
});

Vue.$formly.addValidationMessage('required', i18n.t('validation.required'));

Vue.$formly.addType('mce', MceField);
Vue.$formly.addType('image', ImageField);
Vue.$formly.addType('checkbox', CheckboxField);
Vue.$formly.addType('date', DateField);
Vue.$formly.addType('multi-select', SelectField);
setupInterceptors();

Vue.config.productionTip = false;

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1)
};

Vue.use(VueAnalytics, {
  id: 'UA-105344188-2',
  router
});

export const wait = new VueWait({
  useVuex: true
});

Vue.filter('formatTime', function(time, format = 'DD MMMM YYYY') {
  dayjs.locale('sk');
  return dayjs(time).format(format)
});

let loaded = Array.prototype.slice.call(document.getElementsByTagName('script')).filter((element)  => element.src.match(/\/app\..+\.js/));
if (loaded && loaded.length) {
  loaded = loaded[0].src
}

setInterval(() => {
  axios({baseURL: process.env.BASE_URL, url: '/'}).then((result) => {
    let actual = result.data.match(/src=(\/js)?\/app\..+\.js/);

    if (actual && actual.length) {
      actual = actual[0].split('src=')[1];

      if (!loaded.match(actual)) {
        window.location.reload();
      }
    }
  }, function(){})
}, 30000);

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  wait: wait,
  render: h => h(App)
});
